import React from 'react';

import { Provider } from 'react-redux';

import { Dashboard } from './Components/Dashboard';
import { PageHeader } from './Components/PageHeader.jsx';

import './App.css';

const App = ({ store }) => (
  <Provider store={store}>
    <div>
      <PageHeader header="Historical Duplicate Search" />
      <Dashboard />
    </div>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js